import { CUSTOMER_FORM_ID } from '../../../../global/constants';
import {
  FiscalYear,
  InvoiceRecipient,
  RelationType,
  SignAuthority,
  StockRestrictions,
} from '../../../../global/entities/BuyOrder';
import {
  businessTemplates,
  businessTemplatesDefault,
} from '../../../buy-process-form/components/company-details/company-details-utils';
import { BuyProcessEditState } from './buy-order-edit-types';

export const BUY_ORDER_INITIAL_STATE = {
  clientInfo: {
    person: '',
    relationType: RelationType.ContactPerson,
    email: '',
    emailRepeat: '',
    organizationName: '',
    phoneNumber: '',
  },
  companyDetails: {
    municipality: { id: '', value: '' },
    nameReview: false,
    taxHelp: false,
    co: '',
    address: '',
    businessDescription: businessTemplates[businessTemplatesDefault],
    templateSelect: businessTemplatesDefault,
    city: '',
    postalCode: '',
    secondAlternativeCompanyName: '',
    firstAlternativeCompanyName: '',
    desiredCompanyName: '',
  },
  ownerShares: {
    physicalPeople: [],
    legalShareholders: [],
    shareCapital: 25_000,
    numberShares: 250,
    beneficialOwnerHelp: false,
  },
  reservation: {
    stockRestrictions: StockRestrictions.None,
    rightFirstRefusal: false,
  },
  representatives: {
    representatives: [],
    officialCeo: false,
    signAuthority: SignAuthority.AB1,
    signAuthorityUserDefined: '',
  },
  fiscalYear: {
    firstClosingDate: '',
    fiscalYear: FiscalYear.JanuaryStart,
    extendedFiscalYear: false,
  },
  auditor: {
    auditorOption: 'no',
  },
  proxies: {
    person: '',
    relationId: '',
    relationType: RelationType.PowerOfAttorney,
    bankAccountHelp: false,
  },
  costStatement: {
    totalPayment: {
      totalPayment: 0,
      taxHelpCost: 0,
      registrationCost: 0,
      nameReviewCost: 0,
      beneficialCost: 0,
      administrationCost: 0,
      vat: 0,
    },
    receiverEmails: [],
    receiveOption: 'mail',
    digitalCustomerSignature: false,
    invoiceRecipient: InvoiceRecipient.Company,
    manualHandling: false,
    taxAccountOcr: '',
  },
  metadata: {
    internalDealDate: '',
    internalManagerId: '',
    invoiceNumber: '',
    organizationName: '',
    organizationNumber: '',
    registrationDate: '',
  },
  deleteRequest: [],
} as BuyProcessEditState;

export const buyOrderEditStoreInitialState: Record<
  string,
  BuyProcessEditState
> = {
  [CUSTOMER_FORM_ID]: {
    ...BUY_ORDER_INITIAL_STATE,
  },
};
